<template>
	<div class="video-wrap flex flex-wrap flex-pack-justify"><video-player class="vjs-custom-skin videosa" :options="videoConfig"></video-player></div>
</template>

<script>
import 'videojs-contrib-hls';
export default {
	data() {
		return {
			list: [
				//视频源
				'https://open.ys7.com/v3/openlive/J46595691_1_1.m3u8?expire=1696831998&id=501034771929903104&t=2dbbb847709fcb2ef48b60cb1cc6edbe5fe02db264a48f1a422b12bdc591392e&ev=100',
				'http://ivi.bupt.edu.cn/hls/cctv3hd.m3u8',
				'http://ivi.bupt.edu.cn/hls/cctv5hd.m3u8',
				'http://ivi.bupt.edu.cn/hls/cctv6hd.m3u8'
			]
			// videoConfig: {} //视频配置信息
		};
	},
	props: {
		videoUrl: {
			type: String,
			default: ''
		}
	},
	computed: {
		videoConfig() {
			return {
				// playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
				autoplay: true, //自动播放。
				controls: true, //管制条
				preload: 'auto', //视频预加载
				muted: true, //默认状况下将会打消任何音频。
				loop: true, //导致视频一完结就从新开始。
				language: 'zh-CN',
				aspectRatio: '16:9', // 视频比例（例如"16:9"或"4:3"）
				fluid: true, //窗体自适应
				sources: [
					{
						type: 'application/x-mpegURL',
						src: this.videoUrl
					}
				],
				// poster:"", //视频封面
				// width: document.documentElement.clientWidth,
				notSupportedMessage: '此视频暂无奈播放，请稍后再试'
			};
		}
	},
	mounted() {
		// this.getVideoList();
	},

	methods: {}
};
</script>
<style scoped lang="scss">
.video-wrap {
	margin-left: 30px;
}
::v-deep .videosa {
	width: 100%;
	margin-bottom: 18px;
}
</style>
